import React from 'react';
import { useLanguage } from '../components/LanguageContext';
import '../styles/Projects.css';

const Projects: React.FC = () => {
  const { language } = useLanguage(); // Obtén el idioma actual

  const projects = [
    {
      imgSrc: '/Huevito.png',
      altText: 'rastreador-de-gastos',
      title: { es: 'Torneo de cell', en: 'Cell tournament' },
      description: { es: 'Un videojuego PWA hecho con la libreria phaser', en: 'A PWA video game made with the Phaser library' },
      link: 'https://github.com/AnGeMoNs/TorneoDeCell',
    },
    {
      imgSrc: '/Comercio.png',
      altText: 'tercer-proyecto',
      title: { es: 'Comercio Electronico', en: 'E-commerce' },
      description: { es: 'Una tienda hecha con React-TypeScript-Mysql', en: 'A store made with React-TypeScript-MySQL' },
      link: 'https://github.com/AnGeMoNs/Ecommerce-React-Mysql',
    },
    {
      imgSrc: '/RedSocial.png',
      altText: 'netflic-clone',
      title: { es: 'Red Social', en: 'Social Network' },
      description: { es: 'Una red social donde puedes crear publicaciones, hecha con ReactJs-MongoDb', en: 'A social network where you can create posts, made with ReactJs-MongoDb' },
      link: 'https://github.com/AnGeMoNs/SocialRed',
    },
  ];

  return (
    <section className="proyectos" id="proyectos">
      <h2 className="titulo-de-proyectos">
        {language === 'es' ? 'Algunos de mis proyectos' : 'Some of my projects'}
      </h2>
      <div className="contenedor-de-proyectos">
        {projects.map((project, index) => (
          <div key={index} className="contenedor-de-proyectos tarjeta-de-proyectos">
            <img
              src={project.imgSrc}
              alt={project.altText}
              loading="lazy"
              className="project-pic"
            />
            <h3 className="titulo-de-proyectos">
              {language === 'es' ? project.title.es : project.title.en}
            </h3>
            <p className="detalle-de-proyectos">
              {language === 'es' ? project.description.es : project.description.en}
            </p>
            <button
              className="enlace-de-proyectos"
              onClick={() => window.open(project.link, '_blank')}
            >
              {language === 'es' ? 'Échale un vistazo!' : 'Check it out!'}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;

